// src/pages/TermsAndConditions.js
import React from 'react';
import '../styles/pages/Page.css';
import '../styles/pages/LegalPage.css';

const TermsAndConditions = () => {
  return (
    <div className="page-container">
      <div className="container legal-container">
        <div className="legal-header">
          <p className="m-eyebrow">Legal</p>
          <h1 className="page-title">Terms &amp; Conditions</h1>
          <p className="legal-last-updated">Last updated: March 2026</p>
        </div>

        <div className="legal-body">

          <section className="legal-section">
            <h2>1. Acceptance of Terms</h2>
            <p>
              By creating a Michii account or using the Michii Chrome extension, you
              agree to be bound by these Terms and Conditions. If you do not agree, do not
              use the service.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Use of the Service</h2>
            <p>You agree to use Michii only for lawful purposes. You must not:</p>
            <ul>
              <li>Record or share guides that contain sensitive personal data of others without their consent.</li>
              <li>Use Michii to automate actions that violate a third-party website's terms of service.</li>
              <li>Attempt to reverse-engineer, scrape, or exploit the Michii API.</li>
              <li>Upload or share content that is illegal, abusive, or infringes intellectual property.</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. Your Content</h2>
            <p>
              You retain ownership of the guides and content you create. By using Michii,
              you grant us a limited, non-exclusive licence to store and serve your content
              solely for the purpose of operating the service.
            </p>
            <p>
              When you mark a guide as Public, you grant other Michii users the right to
              view and use that guide. You can revert a guide to Private at any time.
            </p>
          </section>

          <section className="legal-section">
            <h2>4. Account Responsibility</h2>
            <p>
              You are responsible for maintaining the confidentiality of your account
              credentials. You are responsible for all activity that occurs under your
              account. Notify us immediately if you suspect unauthorised access.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. Availability and Changes</h2>
            <p>
              We aim to keep Michii available at all times but do not guarantee
              uninterrupted access. We may modify, suspend, or discontinue features with
              reasonable notice. We are not liable for losses resulting from downtime or
              changes.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Limitation of Liability</h2>
            <p>
              Michii is provided "as is" without warranties of any kind. To the maximum
              extent permitted by law, we are not liable for indirect, incidental, or
              consequential damages arising from your use of the service.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Termination</h2>
            <p>
              We reserve the right to suspend or terminate accounts that violate these
              terms. You may delete your account at any time. Upon termination, your guides
              and personal data will be deleted in accordance with our Privacy Policy.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Governing Law</h2>
            <p>
              These terms are governed by the laws of India. Any disputes shall be subject
              to the exclusive jurisdiction of the courts located in India.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Contact</h2>
            <p>
              Questions about these terms? Reach us via the{' '}
              <a href="/contact" className="legal-inline-link">Contact Us</a> page.
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
